import { Theme } from '@mui/material';

const paperContainer = {
  '&.MuiPaper-root': {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 0px 20px 16px',
    borderRadius: '8px',
    boxShadow: '0px 8px 20px -8px rgba(0, 0, 0, 0.25)',
    '& .MuiAutocomplete-listbox': {
      padding: 0,
    },
    '& .MuiAutocomplete-option': {
      padding: '5px 0px 5px 0px',
    },
    '& .MuiAutocomplete-noOptions': {
      padding: 0,
    },

    backgroundColor: (theme: Theme) => (theme.palette.theme === 'lio' ? 'white' : ''),
    '--Paper-overlay': (theme: Theme) =>
      theme.palette.theme !== 'lio'
        ? 'linear-gradient(rgba(255, 255, 255, 0.119), rgba(255, 255, 255, 0.119)) !important'
        : '',
  },
} as const;

export { paperContainer };
